import { render, staticRenderFns } from "./checkCourierNumber.vue?vue&type=template&id=2881c305&"
import script from "./checkCourierNumber.vue?vue&type=script&lang=js&"
export * from "./checkCourierNumber.vue?vue&type=script&lang=js&"
import style0 from "./checkCourierNumber.vue?vue&type=style&index=0&id=2881c305&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports